import { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import logError from 'src/data/services/logError';
import { useEventStore } from 'src/domain/stores/useEventStore';
import { useNavigationStore } from 'src/domain/stores/useNavigationStore';

/** A fetch younger than this is treated as fresh enough, so reopening a screen does not refetch. */
export const FRESH_EVENT_MAX_AGE_MS = 30_000;

/**
 * Refreshes one event from the server when the screen it lives on gains focus (open or return).
 */
export function useFreshEvent(eventUuid: string | undefined): void {
	useFocusEffect(
		useCallback(() => {
			if (!eventUuid) {
				return;
			}
			if (!useNavigationStore.getState().isConnected) {
				return;
			}

			const { lastFetchedAt, fetchEventFromApi } = useEventStore.getState();
			const fetchedAt = lastFetchedAt[eventUuid] ?? 0;
			if (Date.now() - fetchedAt < FRESH_EVENT_MAX_AGE_MS) {
				return;
			}

			fetchEventFromApi(eventUuid, { silent: true, updateActiveView: false }).catch(logError);
		}, [eventUuid]),
	);
}

export default useFreshEvent;
